/**
 * GlobalLoader — full-viewport branded loader.
 *
 * Rendered by __root.tsx while the session query resolves. Kept visually
 * identical to the static #app-loader in index.html so the handoff
 * (bundle parse → session fetch) is seamless: animated logo above a short
 * loading message.
 *
 * Intentionally has zero app dependencies (no useTranslation): it renders
 * *before* the session resolves, and the localization bundle query is gated
 * on `!!session`, so t() could only ever return the English fallback here
 * while firing a wasted bundle request during boot. The loading message is
 * therefore hardcoded, matching the index.html bootstrap twin, which has no
 * t() available at all. The visible message is also the `role="status"`
 * region's accessible name — so no separate aria-label is needed.
 */
import LogoSpinner from '@components/ui/LogoSpinner/LogoSpinner';
import styles from './GlobalLoader.module.scss';

function GlobalLoader() {
  return (
    <div className={styles.root} role="status" aria-live="polite">
      <div className={styles.backdrop} aria-hidden="true" />
      <div className={styles.content}>
        <LogoSpinner size="lg" />
        <p className={styles.text}>Getting your dashboard ready...</p>
      </div>
    </div>
  );
}

export default GlobalLoader;
